export default {
	utc: {
		format: function (value: any): string {
			if (value === undefined) {
				return 'undefined'
			}

			const dateIso = new Date(value).toISOString()
			const dateOnly = dateIso?.split('T')?.[0]
			const dateArray = dateOnly?.split('-')

			const year = dateArray?.[0]
			const month = dateArray?.[1]
			const day = dateArray?.[2]

			const result = `${day}/${month}/${year}`

			return result
		},
		convertTimezoneToUTC(date) {
			const timeDifferenceInMs = -3 * 60 * 60 * 1000
			let isoDate = date

			if (!date.includes('Z')) {
				isoDate = date.replace('+00:00', 'Z')
			}

			const ms = new Date(isoDate).getTime()
			const dateSp = new Date(ms + timeDifferenceInMs)
				.toISOString()
				.replace('Z', '-03:00')

			return dateSp
		},
	},
	userTimezone: {
		formatDateAndTime: function (value: any): string {
			if (value === undefined) {
				return 'undefined'
			}

			const d = new Date(value)

			const year = d.getFullYear()
			const month = keepMinLength(d.getMonth() + 1)
			const day = keepMinLength(d.getDate())

			const hours = keepMinLength(d.getHours())
			const minutes = keepMinLength(d.getMinutes())

			return `${day}/${month}/${year} ${hours}:${minutes}`
		},

		getYear: function (date: any) {
			const d = new Date(parseInt(date, 10))

			return d.getFullYear()
		},

		getMonth(date: any) {
			const d = new Date(date)
			return d.getMonth() + 1
		},

		getMonthString(date: any) {
			const d = new Date(date)
			const mo = d.getMonth()
			const monthStrings = [
				'Janeiro',
				'Fevereiro',
				'Março',
				'Abril',
				'Maio',
				'Junho',
				'Julho',
				'Agosto',
				'Setembro',
				'Outubro',
				'Novembro',
				'Dezembro',
			]

			return monthStrings[mo]
		},
	},
	sao_paulo: {
		convertTimezoneToSp(date) {
			const timeDifferenceInMs = -3 * 60 * 60 * 1000
			let isoDate = date

			if (!date.includes('Z')) {
				isoDate = date.replace('+00:00', 'Z')
			}

			const ms = new Date(isoDate).getTime()
			const dateSp = new Date(ms + timeDifferenceInMs)
				.toISOString()
				.replace('Z', '-03:00')

			return dateSp
		},
	},
	shortDate(dateString) {
		const d = new Date(dateString)
		return new Intl.DateTimeFormat('pt-BR', {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
		}).format(d)
	},
	daysUntil(dataAlvo: string | Date): number {
		const hoje = new Date()
		// Zera as horas, minutos e segundos de hoje para contar dias inteiros
		hoje.setHours(0, 0, 0, 0)

		const dataDestino = new Date(dataAlvo)
		// Zera as horas da data alvo também
		dataDestino.setHours(0, 0, 0, 0)

		// Calcula a diferença em milissegundos
		const diferencaMs = dataDestino.getTime() - hoje.getTime()

		// Converte milissegundos para dias (1000ms * 60s * 60m * 24h)
		const milissegundosPorDia = 1000 * 60 * 60 * 24
		const dias = Math.ceil(diferencaMs / milissegundosPorDia)

		return dias > 0 ? dias : 0
	},
}

function keepMinLength(value) {
	if (value.toString().length < 2) {
		return '0' + value
	}

	return value
}
